import { CloseCircleFilled } from "@ant-design/icons"
import { useNotification } from "components/Notification/Notification"
import { useEffect, useState } from "react"
import { getBase64 } from "utils/file"
import { Video } from "./Video"

export function VideoThumbnail({
	file,
	disabled,
	onRemove,
}: {
	file: File
	disabled: boolean
	onRemove: VoidFunction
}) {
	const { notify } = useNotification()
	const [src, setSrc] = useState<string>()

	useEffect(() => {
		async function loadBase64() {
			const result = await getBase64(file)
			setSrc(result as string)
		}
		loadBase64()
	}, [file])

	if (!src) {
		return null
	}

	return (
		<div className="relative flex size-10 rounded-lg outline-green-20 focus:outline-2">
			<Video
				src={src}
				aria-label={`Video thumbnail ${file.name}`}
				className="aspect-square rounded-lg object-cover text-[6px]"
				onError={() => notify.error({ message: "Not a valid video" })}
			/>

			{!disabled && (
				<CloseCircleFilled
					tabIndex={0}
					role="button"
					aria-label={`Remove video ${file.name}`}
					className="absolute -top-1 -right-1 size-4 place-content-center rounded-full bg-white outline-green-20 hover:cursor-pointer"
					onClick={onRemove}
					onKeyDown={(e) => {
						if (e.key === "Enter" || e.key === " ") {
							onRemove()
						}
					}}
				/>
			)}
		</div>
	)
}
